import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgPillsGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.375 11.125c0-.875-.75-1.625-1.625-1.625v.125h-25.5c-.875 0-1.625.75-1.625 1.625v25.5c0 .875.75 1.625 1.625 1.625h25.5c.875 0 1.625-.75 1.625-1.625V11.125ZM11.25 8h25.5C38.625 8 40 9.375 40 11.25v25.5c0 1.875-1.5 3.25-3.25 3.25h-25.5C9.375 40 8 38.5 8 36.75v-25.5C8 9.375 9.375 8 11.25 8Zm1.5 8c0-.75.625-1.375 1.375-1.375S15.5 15.25 15.5 16s-.625 1.25-1.375 1.375c-.75 0-1.375-.625-1.375-1.375Zm11.5-1.375c-.75 0-1.375.625-1.375 1.375s.625 1.375 1.375 1.375 1.375-.625 1.375-1.375-.625-1.375-1.375-1.375ZM33 16c0-.75.625-1.375 1.375-1.375S35.75 15.25 35.75 16s-.625 1.375-1.375 1.375S33 16.75 33 16Zm-18.875 6.625c-.75 0-1.375.625-1.375 1.375s.625 1.375 1.375 1.375S15.5 24.75 15.5 24s-.625-1.375-1.375-1.375ZM22.875 24c0-.75.625-1.375 1.375-1.375s1.375.625 1.375 1.375-.625 1.375-1.375 1.375-1.375-.625-1.375-1.375Zm11.5-1.375c-.75 0-1.375.625-1.375 1.375s.625 1.375 1.375 1.375S35.75 24.75 35.75 24s-.625-1.375-1.375-1.375Zm-21.625 9.5c0-.75.625-1.375 1.375-1.375s1.375.625 1.375 1.375-.625 1.375-1.375 1.375-1.375-.625-1.375-1.375Zm11.5-1.375c-.75 0-1.375.625-1.375 1.375S23.5 33.5 24.25 33.5s1.375-.625 1.375-1.375S25 30.75 24.25 30.75ZM33 32.125c0-.75.625-1.375 1.375-1.375s1.375.625 1.375 1.375-.625 1.375-1.375 1.375S33 32.875 33 32.125Z",
    fill: "currentColor"
  }));
}

export { SvgPillsGlyph as default };
